import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import QtyInput from '../../Shared/QtyInput'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'

const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

function calculateTileCount(itemsQuantity, itemsWaste, numberOfParts, outputsWaste) {

  let res = 0;

  res = (((itemsQuantity - itemsWaste) * numberOfParts) - outputsWaste) || 0;

  return res > 0 ? res : 0

}

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <>
    <div className="row display-flex">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <fieldset className="fieldset">
          <legend>مواد اولیه</legend>
          <table className="table validator-table" style={{ marginBottom: 5 }}>
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">نام کالا</th>
                <th className="text-center">مقدار اولیه</th>
                {values.unitTaskStatus === 2 ?
                  <th className="text-center">تعداد کل ورق بکار رفته</th>
                  : ''}
                {values.unitTaskStatus === 2 ?
                  <th className="text-center">تعداد ضایعات از ورق های بکار رفته</th>
                  : ''}
                {/* <th className="text-center">واحد شمارش</th> */}
              </tr>
            </thead>
            <tbody>
              {values.items && values.items.map((item, index) => (
                <tr key={"p-" + index}>
                  <td>{index + 1}</td>
                  <td>
                    {values.items[index].product && values.items[index].product.category.name}
                  </td>
                  <td>
                    {values.items[index].product && values.items[index].product.brand.name}
                  </td>
                  <td>
                    {values.items[index].product && values.items[index].product.name}
                  </td>
                  <td>
                    {values.items[index].product !== undefined &&
                      <div className="flex-col flex-center">
                        <MeasurementTypeDoubleBox
                          product={values.items[index].product}
                          value={values.items[index].firstQuantity}
                          onlySub
                        />
                      </div>
                    }
                  </td>
                  {values.unitTaskStatus === 2 ?
                    <td>
                      {values.items[index].product !== undefined &&
                        <QtyInput
                          disabled={values.items[index].product && values.items[index].product.conversionUnit && values.items[index].product.measurementType !== values.items[index].product.subMeasurementType ? true : false}
                          className="text-input"
                          measurementType={values.items[index].product ? values.items[index].product.measurementType : undefined}
                          subMeasurementType={values.items[index].product ? values.items[index].product.subMeasurementType : undefined}
                          conversionUnit={values.items[index].product ? values.items[index].product.conversionUnit : undefined}
                          onChange={(val, subVal) => {

                            // if (subVal) {

                            // if (val <= values.items[index].unitProductQuantity) {
                            setFieldValue(`items[${index}][subQuantity]`, subVal)
                            // } else {
                            //   setFieldValue(`items[${index}][subWaste]`, undefined)
                            //   setFieldValue(`items[${index}][waste]`, undefined)
                            // }

                            // } else {
                            //   setFieldValue(`items[${index}][subWaste]`, undefined)
                            // }

                            setFieldValue(`items[${index}][quantity]`, val)



                            let q = calculateTileCount(subVal, values.items[0].subWaste, values.items[0].product.numberOfParts, values.outputs[0].waste) || 0;
                            setFieldValue(`outputs[${index}][quantity]`, q)
                            setFieldValue(`outputs[${index}][subQuantity]`, q)

                          }}
                        // max={values.items[index].quantity}
                        // value={values.items[index].quantity}
                        />
                      }
                      <ErrorMessage component={ErrorPopUp} name={`items[${index}].quantity`} style={{ margin: '0 auto' }} />
                    </td>
                    : ''}
                  {values.unitTaskStatus === 2 ?
                    <td>
                      <div>
                        <QtyInput
                          disabled={values.items[index].product ? values.items[index].product.conversionUnit : false}
                          className="text-input"
                          measurementType={values.items[index].product ? values.items[index].product.measurementType : undefined}
                          subMeasurementType={values.items[index].product ? values.items[index].product.subMeasurementType : undefined}
                          conversionUnit={values.items[index].product ? values.items[index].product.conversionUnit : undefined}
                          onChange={(val, subVal) => {

                            // if (subVal) {

                            // if (val <= values.items[index].unitProductQuantity) {
                            setFieldValue(`items[${index}][subWaste]`, subVal)
                            // } else {
                            //   setFieldValue(`items[${index}][subWaste]`, undefined)
                            //   setFieldValue(`items[${index}][waste]`, undefined)
                            // }

                            // } else {
                            //   setFieldValue(`items[${index}][subWaste]`, undefined)
                            // }

                            setFieldValue(`items[${index}][waste]`, val)



                            let q = calculateTileCount(values.items[0].subQuantity, subVal, values.items[0].product.numberOfParts, values.outputs[0].waste) || 0;
                            setFieldValue(`outputs[${index}][quantity]`, q)
                            setFieldValue(`outputs[${index}][subQuantity]`, q)

                          }}
                          // max={values.items[index].quantity}
                          value={values.items[index].waste}
                        />
                        <ErrorMessage component={ErrorPopUp} name={`items[${index}].waste`} style={{ margin: '0 auto' }} />
                      </div>
                    </td>
                    : ''}
                  {/* <td>
                    {values.items[index].product ? measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label : ''}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>
      </div>
    </div>
  </>
);